import React, { useEffect, useRef } from 'react';
export const HeroSection = () => {
  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-fade-in');
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section ref={sectionRef} className="relative pt-28 pb-24 md:pt-36 md:pb-32 lg:pt-44 lg:pb-40 opacity-0 transition-opacity duration-1000" data-id="element-2631">
      {/* Background image with gradient overlay */}
      <div className="absolute inset-0 z-0" data-id="element-2632">
        <div className="absolute inset-0 bg-cover bg-center" style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')"
      }} data-id="element-2633"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal/80 via-charcoal/70 to-charcoal/90" data-id="element-2634"></div>
      </div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-2635">
        <div className="max-w-4xl mx-auto text-center" data-id="element-2636">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight mb-8 text-white tracking-tight" data-id="element-2637">
            Train. Upskill. <br className="hidden sm:block" data-id="element-2638" />
            Stay Compliant —
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-2639">
            Accredited compliance training, workplace skills, and business
            courses — built to meet legislation and trusted by businesses of
            every size.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-5" data-id="element-2640">
            <a href="/courses" className="px-8 py-4 bg-teal text-white font-medium rounded-md hover:bg-gradient-to-r hover:from-teal hover:to-aqua transition-all duration-300 shadow-lg transform hover:-translate-y-1" data-id="element-2641">
              Explore Courses
            </a>
            <a href="/contact" className="px-8 py-4 bg-transparent text-white font-medium rounded-md border-2 border-white hover:bg-white/10 transition-all duration-300 transform hover:-translate-y-1" data-id="element-2642">
              Book a Demo
            </a>
          </div>
        </div>
      </div>
    </section>;
};